import React from 'react'
import OptiScoreNew from "pages/Legacy/Marketing/components/OptiScore/OptiScoreNew";

const OptiScore = ({ row, isCa }: any) => {
  
  return <OptiScoreNew row={row} isCa={isCa} />
}

export default OptiScore
